// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TrpC","buttons":"styles_buttons__u8Ndr"};